import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';

export interface IFormBoxProps {
  style?: React.CSSProperties;
  visible?: boolean;
}

const FormBox = observer(({ children }: { children?: React.ReactNode }) => {
  const field = useField<VoidField>();
  const { style, visible } = (field?.componentProps || {}) as IFormBoxProps;

  if (visible === false) return null;

  return <div style={style}>{children}</div>;
});

export default FormBox;
